module.exports = __webpack_public_path__ + "static/media/dots.ab7f6050.gif";